import { render, staticRenderFns } from "./DashboardAdvertBarPro.vue?vue&type=template&id=11669a70"
import script from "./DashboardAdvertBarPro.vue?vue&type=script&lang=js"
export * from "./DashboardAdvertBarPro.vue?vue&type=script&lang=js"
import style0 from "./DashboardAdvertBarPro.vue?vue&type=style&index=0&id=11669a70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports